<template>
  <dl>
    <dl v-for="(chunk, index) in chunkedTags" :key="chunk.join('_')" class="tag-row">
      <v-chip
        v-for="item in chunk"
        :key="`${item}`"
        tag="dd"
        small
        class="mr-1"
        :class="{ 'no-click': isFilteredJobsPage }"
        @click.stop.prevent="isFilteredJobsPage ? null : setSearchValue(item)"
      >
        {{ item }}
      </v-chip>

      <vs-menu v-if="showViewMoreTags(index)" :items="overflowTagMenuItem" :max-height="320">
        <template #activator>
          <v-chip tag="dd" small outlined class="ma-1 mt-0" @click.prevent>
            + {{ overflowTags.length }}
          </v-chip>
        </template>
      </vs-menu>
    </dl>
  </dl>
</template>

<script setup lang="ts">
import { chunk } from 'lodash'
import { computed } from 'vue'
import { useJobFilterStore } from '@/components/field-view-next/JobsFilterStore'
import { useRoute } from 'vue-router/composables'

const props = withDefaults(
  defineProps<{
    value: string[]
  }>(),
  {
    value: () => [],
  },
)

const visibleTagCount = 8
const tagsPerRow = 4

const store = useJobFilterStore()
const route = useRoute()

const isFilteredJobsPage = computed(() => {
  return route.path.includes('/jobs')
})

const visibleTags = computed(() => {
  return props.value?.slice(0, visibleTagCount)
})

const overflowTags = computed(() => {
  return props.value.filter((tag) => !visibleTags.value.includes(tag))
})

const overflowTagMenuItem = computed(() => {
  return overflowTags.value.map((tag) => {
    return {
      text: tag,
      onClick: () => (isFilteredJobsPage.value ? null : setSearchValue(tag)),
    }
  })
})

const chunkedTags = computed(() => {
  return chunk(visibleTags.value, tagsPerRow)
})

const showViewMoreTags = (index) => {
  return props.value.length > visibleTagCount && chunkedTags.value.length - 1 === index
}

const setSearchValue = (search: string) => {
  if (isFilteredJobsPage.value) return
  const formattedSearch = `tag:"${search}"`
  store.updateSearch(formattedSearch)
}
</script>

<style scoped>
.tag-row:not(:last-child) {
  margin-bottom: var(--space-smaller);
}

.no-click {
  cursor: default !important;
  pointer-events: none;
}
</style>
